import base64 from "react-native-base64";
import { firebase } from "../config/configureFirebase";
import AccessKey from "./AccessKey";
import store from "../store/store";

export const fetchPlacesAutocomplete = (searchKeyword) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        const settings = store.getState().settingsdata.settings;
        const auth = store.getState().auth;

        console.log("auth from fetchPlacesAutocomplete", auth);

        //get country code from gps
        return getCountryCodeFromGPS()
            .then((value) => {
                // Get user's country_code from auth profile
                let userCountryCode = value;

                //get list countries
                const countries = store.getState().countrylistdata.countries;

                // Default to Panama if no user country_code
                if (!userCountryCode) {
                    reject("country_not_supported");
                }

                //check userCountryCode as existing in countries list
                const existingCountry = countries.find(
                    (country) => country.country_code === userCountryCode
                );
                if (!existingCountry && settings.restricted_countries == true) {
                    reject("country_not_supported");
                }

                // Always use user's country_code for restricted_countries
                // This ensures the search is always restricted to user's country
                const restrictedCountries = userCountryCode;

                const requestBody = {
                    searchKeyword: searchKeyword,
                    maplang: settings.mapLanguage,
                    user_country_code: userCountryCode,
                    restricted_countries: restrictedCountries,
                };

                console.log(
                    "Mobile App - fetchPlacesAutocomplete request:",
                    requestBody
                );
                console.log(
                    "Mobile App - API URL:",
                    `https://us-central1-${config.projectId}.cloudfunctions.net/googleapis-autocomplete`
                );

                fetch(
                    `https://us-central1-${config.projectId}.cloudfunctions.net/googleapis-autocomplete`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization:
                                "Basic " +
                                base64.encode(
                                    config.projectId + ":" + AccessKey
                                ),
                        },
                        body: JSON.stringify(requestBody),
                    }
                )
                    .then((response) => {
                        return response.json();
                    })
                    .then((json) => {
                        if (json && json.searchResults) {
                            resolve(json.searchResults);
                        } else {
                            reject(json.error);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        reject("fetchPlacesAutocomplete Call Error");
                    });
            })
            .catch((error) => {
                console.log("error from getCountryCodeFromGPS", error);
            });
    });
};

export const fetchCoordsfromPlace = (place_id) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        const settings = store.getState().settingsdata.settings;
        fetch(
            `https://us-central1-${config.projectId}.cloudfunctions.net/googleapis-getcoords`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Basic " +
                        base64.encode(config.projectId + ":" + AccessKey),
                },
                body: JSON.stringify({
                    place_id: place_id,
                    maplang: settings.mapLanguage,
                }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                if (json && json.coords) {
                    resolve(json.coords);
                } else {
                    reject(json.error);
                }
            })
            .catch((error) => {
                console.log(error);
                reject("fetchCoordsfromPlace Call Error");
            });
    });
};

export const fetchAddressfromCoords = (latlng) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        const settings = store.getState().settingsdata.settings;
        fetch(
            `https://us-central1-${config.projectId}.cloudfunctions.net/googleapis-getaddress`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Basic " +
                        base64.encode(config.projectId + ":" + AccessKey),
                },
                body: JSON.stringify({
                    latlng: latlng,
                    maplang: settings.mapLanguage,
                }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                if (json && json.address) {
                    resolve(json.address);
                } else {
                    reject(json.error);
                }
            })
            .catch((error) => {
                console.log(error);
                reject("fetchAddressfromCoords Call Error");
            });
    });
};

export const getDistanceMatrix = (startLoc, destLoc) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        const settings = store.getState().settingsdata.settings;
        fetch(
            `https://us-central1-${config.projectId}.cloudfunctions.net/googleapis-getdistancematrix`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Basic " +
                        base64.encode(config.projectId + ":" + AccessKey),
                },
                body: JSON.stringify({
                    start: startLoc,
                    dest: destLoc,
                    maplang: settings.mapLanguage,
                }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                if (json.error) {
                    console.log(json.error);
                    reject(json.error);
                } else {
                    resolve(json);
                }
            })
            .catch((error) => {
                console.log(error);
                reject("getDistanceMatrix Call Error");
            });
    });
};

export const getDirectionsApi = (startLoc, destLoc, waypoints) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        const settings = store.getState().settingsdata.settings;
        const body = {
            start: startLoc,
            dest: destLoc,
            maplang: settings.mapLanguage,
        };
        if (waypoints) {
            body["waypoints"] = waypoints;
        }
        fetch(
            `https://us-central1-${config.projectId}.cloudfunctions.net/googleapis-getdirections`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Basic " +
                        base64.encode(config.projectId + ":" + AccessKey),
                },
                body: JSON.stringify(body),
            }
        )
            .then(async (response) => {
                const data = await response.json();

                return data;
            })
            .then((json) => {
                if (json.hasOwnProperty("distance_in_km")) {
                    resolve(json);
                } else {
                    console.log(json.error);
                    reject(json.error);
                }
            })
            .catch((error) => {
                console.log(error);
                reject("getDirectionsApi Call Error");
            });
    });
};

/**
 * Get the country code based on the device's current GPS location.
 * This function uses the Geolocation API to get the current position,
 * then calls the Google Geocoding API to retrieve the country code.
 *
 * @returns {Promise<string>} The ISO country code (e.g., 'US', 'ID', etc.)
 */
export const getCountryCodeFromGPS = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            const { config } = firebase;
            const auth = store.getState().auth;

            // Get current location - try multiple methods
            let lat = null;
            let lng = null;

            // Method 1: Try browser geolocation (for web)
            if (typeof navigator !== "undefined" && navigator.geolocation) {
                try {
                    const position = await new Promise(
                        (posResolve, posReject) => {
                            navigator.geolocation.getCurrentPosition(
                                posResolve,
                                posReject,
                                {
                                    enableHighAccuracy: true,
                                    timeout: 15000,
                                    maximumAge: 0, // Don't use cached location
                                }
                            );
                        }
                    );
                    lat = position.coords.latitude;
                    lng = position.coords.longitude;
                    console.log("Got GPS coordinates from browser:", lat, lng);
                } catch (geoError) {
                    console.log("Browser geolocation failed:", geoError);
                }
            }

            // Method 2: For React Native, try to get from Redux store if available
            if (!lat || !lng) {
                const gpsData = store.getState().gpsdata;
                if (
                    gpsData &&
                    gpsData.location &&
                    gpsData.location.lat &&
                    gpsData.location.lng
                ) {
                    lat = gpsData.location.lat;
                    lng = gpsData.location.lng;
                    console.log(
                        "Got GPS coordinates from Redux store:",
                        lat,
                        lng
                    );
                }
            }

            // Call Firebase Cloud Function for country detection
            const requestBody = {};
            if (lat && lng) {
                requestBody.lat = lat;
                requestBody.lng = lng;
                console.log(
                    "Sending GPS coordinates to Firebase function:",
                    lat,
                    lng
                );
            } else {
                console.log(
                    "No GPS coordinates available, will use default country"
                );
            }

            const response = await fetch(
                `https://us-central1-${config.projectId}.cloudfunctions.net/googleapis-getCountryCode`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization:
                            "Basic " +
                            base64.encode(config.projectId + ":" + AccessKey),
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            const data = await response.json();

            if (data.success && data.country_code) {
                console.log(
                    "Country detected:",
                    data.country_code,
                    "Method:",
                    data.method
                );
                resolve(data.country_code);
            } else {
                console.log("Country detection failed, using fallback");
                resolve("ID"); // Default to Indonesia
            }
        } catch (error) {
            console.log("Error in getCountryCodeFromGPS:", error);
            resolve("ID"); // Default to Indonesia
        }
    });
};
